import { useContext, useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";

import { AuthContext } from "../auth/AuthContext";

export const RoutesAdmin = ({ children }) => {
  const { tknAdmin } = useContext(AuthContext);
  const { id } = useParams();
  let authenticated = false;
  useEffect(() => {
    chek();
  }, []);
  const chek = async () => {
    authenticated = await tknAdmin(id);
  };
  return authenticated ? children : <Navigate to="/auth/login" />;
};
